const calculatePagesCount = (pageSize: number, totalCount: number) => {
  const pages = totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
  return pages - 1;
};

export default calculatePagesCount;
